{
  "instances": {
    "env": {
      "label": "Environnement",
      "manager": "Gestionnaire d'environnement",
      "active_profile": "Profil",
      "context_refresh": "Rafraîchir le contexte",
      "context_refresh_failed": "Echec",
      "context_refreshed": "Contexte rafraîchi",
      "context_reset": "Réinitialiser",
      "context_reset_failed": "Echec",
      "context_resetted": "Réinitialisé",
      "context_update": "Mettre à jour",
      "context_update_failed": "Echec",
      "context_updated": "Mis à jour",
      "no_properties": "Pas de propriétés définies",
      "title": "Gestion d'environnement",
      "refresh": "Refresh environment",
      "application": "Application",
      "instance": "Instance"
    }
  }
}
